module.exports = __webpack_public_path__ + "static/media/man2.07066282.jpg";